var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFirstStep = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 564,
    height: 560,
    viewBox: "0 0 564 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.599 502.928C480.429 489.562 496.327 472.248 508.327 449.755C578.175 318.909 562.387 125.946 427.873 43.216C365.711 4.98505 276.202 -19.2316 209.018 20.0502C154.518 51.9154 121.109 111.883 93.4806 166.449C76.1042 200.771 61.7949 237.706 40.386 269.816C12.6229 311.468 -17.9508 367.074 12.9161 415.458C54.9641 481.363 134.38 511.457 206.391 531.275C284.523 552.767 372.371 555.821 444.552 513.901C450.393 510.504 456.088 506.851 461.599 502.941V502.928Z",
    fill: "#62B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M461.599 502.928C480.429 489.562 496.327 472.248 508.327 449.755C578.175 318.909 562.387 125.946 427.873 43.216C365.711 4.98505 276.202 -19.2316 209.018 20.0502C154.518 51.9154 121.109 111.883 93.4806 166.449C76.1042 200.771 61.7949 237.706 40.386 269.816C12.6229 311.468 -17.9508 367.074 12.9161 415.458C54.9641 481.363 134.38 511.457 206.391 531.275C284.523 552.767 372.371 555.821 444.552 513.901C450.393 510.504 456.088 506.851 461.599 502.941V502.928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.023 284.49C357.023 284.49 361.605 285.407 364.355 281.057",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M545.059 82.8765H443.636V216.056H545.059V82.8765Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.449 107.313H462.247V191.619H526.449V107.313Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M543.838 559.389H563.389",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3906 559.389H531.618",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.15 40.6868H25.1726V366.988H141.15V40.6868Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 50.6081H140.918L138.217 41.6399",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 61.4701H140.918L138.217 52.5019",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 72.3322H140.918L138.217 63.364",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 83.1942H140.918L138.217 74.226",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 94.0563H140.918L138.217 85.088",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 104.931H140.918L138.217 95.9501",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 115.793H140.918L138.217 106.824",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 126.655H140.918L138.217 117.686",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 137.517H140.918L138.217 128.548",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 148.379H140.918L138.217 139.41",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 159.241H140.918L138.217 150.273",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 170.103H140.918L138.217 161.135",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 180.977H140.918L138.217 171.997",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 191.839H140.918L138.217 182.859",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 202.701H140.918L138.217 193.733",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 213.563H140.918L138.217 204.595",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 224.425H140.918L138.217 215.457",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 235.287H140.918L138.217 226.319",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 246.149H140.918L138.217 237.181",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 257.011H140.918L138.217 248.043",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 267.886H140.918L138.217 258.905",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 278.748H140.918L138.217 269.779",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 289.61H140.918L138.217 280.641",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 300.472H140.918L138.217 291.504",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 311.334H140.918L138.217 302.366",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 322.196H140.918L138.217 313.228",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 333.058H140.918L138.217 324.09",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 343.932H140.918L138.217 334.952",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 354.794H140.918L138.217 345.826",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.864 40.6868H149.887V366.988H265.864V40.6868Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 50.6081H265.644L262.931 41.6399",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 61.4701H265.644L262.931 52.5019",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 72.3322H265.644L262.931 63.364",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 83.1942H265.644L262.931 74.226",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 94.0563H265.644L262.931 85.088",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 104.931H265.644L262.931 95.9501",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 115.793H265.644L262.931 106.824",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 126.655H265.644L262.931 117.686",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 137.517H265.644L262.931 128.548",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 148.379H265.644L262.931 139.41",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 159.241H265.644L262.931 150.273",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 170.103H265.644L262.931 161.135",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 180.977H265.644L262.931 171.997",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 191.839H265.644L262.931 182.859",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 202.701H265.644L262.931 193.733",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 213.563H265.644L262.931 204.595",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 224.425H265.644L262.931 215.457",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 235.287H265.644L262.931 226.319",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 246.149H265.644L262.931 237.181",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 257.011H265.644L262.931 248.043",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 267.886H265.644L262.931 258.905",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 278.748H265.644L262.931 269.779",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 289.61H265.644L262.931 280.641",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 300.472H265.644L262.931 291.504",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 311.334H265.644L262.931 302.366",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 322.196H265.644L262.931 313.228",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 333.058H265.644L262.931 324.09",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 343.932H265.644L262.931 334.952",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 354.794H265.644L262.931 345.826",
    stroke: "black",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.162 18.0219H117.957V292.334H426.162V18.0219Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.162 18.0219H117.957V60.8836H426.162V18.0219Z",
    fill: "#62B6FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.174 18.0219H414.565V292.334H426.174V18.0219Z",
    fill: "#DBDBDB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.174 59.2586H414.565V112.2H426.174V59.2586Z",
    fill: "#949494",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.162 18.0219H117.957V38.8541H426.162V18.0219Z",
    fill: "#DBDBDB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.135 24.1066H133.586V32.7816H255.135V24.1066Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.967 24.5098H418.635",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.967 29.0184H418.635",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.967 33.5269H418.635",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 93H197V100H282V93Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.46 92.6512H222.521V99.9821H319.46V92.6512Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.926 115.463C221.827 115.463 229.853 107.438 229.853 97.5385C229.853 87.6392 221.827 79.6143 211.926 79.6143C202.026 79.6143 194 87.6392 194 97.5385C194 107.438 202.026 115.463 211.926 115.463Z",
    fill: "#62B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.926 112.775C220.342 112.775 227.164 105.953 227.164 97.5385C227.164 89.1237 220.342 82.3023 211.926 82.3023C203.511 82.3023 196.688 89.1237 196.688 97.5385C196.688 105.953 203.511 112.775 211.926 112.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.278 115.463C330.179 115.463 338.205 107.438 338.205 97.5385C338.205 87.6392 330.179 79.6143 320.278 79.6143C310.378 79.6143 302.352 87.6392 302.352 97.5385C302.352 107.438 310.378 115.463 320.278 115.463Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.278 112.775C328.694 112.775 335.516 105.953 335.516 97.5385C335.516 89.1237 328.694 82.3023 320.278 82.3023C311.863 82.3023 305.04 89.1237 305.04 97.5385C305.04 105.953 311.863 112.775 320.278 112.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.823 92.0524C210.704 92.0524 211.12 91.1483 211.499 90.1097H213.136V105.566H210.704V93.7752H208.823V92.0524Z",
    fill: "#62B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.496 92.138C318.727 92.138 318.238 92.5534 318.238 93.6653V95.3147H315.94V93.8119C315.94 91.3438 317.175 89.9265 319.557 89.9265C321.94 89.9265 323.175 91.3438 323.175 93.8119C323.175 98.6625 318.336 100.483 318.336 103.012C318.336 103.122 318.336 103.232 318.36 103.342H322.955V105.554H315.928V103.66C315.928 99.1146 320.743 98.3571 320.743 93.8974C320.743 92.5045 320.254 92.1258 319.484 92.1258L319.496 92.138Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.852 158.19H144.828V172.265H235.852V158.19Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.991 158.19H255.966V172.265H346.991V158.19Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.209 185.852H144.828V199.928H298.209V185.852Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.209 212.5H144.828V226.576H298.209V212.5Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.992 139.081H238.212",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.779 139.081H220.493",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.061 139.081H175.28",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.095 252.307H377.088",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.318 421.848L223.927 529.198L210.62 528.281L207.406 446.162L199.146 445.246L147.298 448.459C147.298 448.459 140.87 447.079 139.037 447.079C137.204 447.079 134.907 442.033 145.917 437.451C156.927 432.869 233.092 418.183 234.925 418.183C236.758 418.183 236.306 421.848 236.306 421.848H236.318Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.283 406.71C164.283 406.71 211.928 390.936 258.338 401.199C262.139 402.042 270.265 498.909 270.265 498.909L257.874 502.574L238.603 425.966C238.603 425.966 157.856 449.364 141.335 447.067C124.814 444.769 164.271 406.697 164.271 406.697L164.283 406.71Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.976 244.781C150.976 244.781 154.642 254.409 154.642 259.003C154.642 263.597 152.503 267.996 152.503 267.996C152.503 267.996 159.701 275.803 158.369 278.76C157.538 280.605 153.872 281.289 153.872 281.289C153.872 281.289 150.67 298.248 147.909 299.164C145.159 300.081 133.685 297.784 133.685 297.784L135.64 320.998L112.875 301.669L114.708 286.995C114.708 286.995 109.197 279.2 102.781 270.024C96.3538 260.848 100.032 246.174 103.698 239.283C107.364 232.404 135.359 218.182 154.165 241.58L150.951 244.793L150.976 244.781Z",
    fill: "#9C9C9C",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7046 252.503C77.2911 250.438 70.8147 249.851 73.1731 244.854C75.5315 239.845 82.5945 240.138 82.3012 236.607C82.0079 233.076 79.6495 233.369 83.7676 229.545C87.8856 225.72 91.1238 227.773 92.3091 223.949C93.4822 220.124 94.3742 216.3 94.3742 216.3L97.0259 214.235C98.7733 212.879 100.386 214.198 101.278 215.261C103.686 216.043 105.971 219.232 108.256 218.951C111.628 218.536 112.472 209.69 119.205 210.105C125.95 210.521 123.42 221.481 125.95 220.638C128.479 219.794 133.526 216.422 140.271 218.108C147.017 219.794 140.271 226.111 142.801 225.684C145.33 225.268 160.067 222.311 161.338 226.099C162.597 229.887 153.334 234.945 153.334 234.945C153.334 234.945 164.711 231.573 161.338 237.89C157.966 244.207 150.988 244.769 150.988 244.769C150.988 244.769 155.497 246.443 153.664 248.495C152.076 250.279 146.882 250.694 145.526 250.768L145.294 251.024C145.734 252.124 147.188 256.706 141.75 258.111C140.284 258.49 139.098 258.734 138.121 258.905L137.302 259.797C137.791 261.043 138.316 262.351 138.585 263.56C139.428 267.348 132.683 269.462 130.166 269.462C127.648 269.462 125.534 277.88 127.636 280.409C128.113 280.984 128.272 281.668 128.223 282.389C128.626 282.816 128.944 283.171 129.127 283.391C130.3 284.857 131.485 289.866 130.007 290.746C128.541 291.626 122.651 290.746 122.651 290.746C122.651 290.746 121.771 297.808 119.119 298.395C116.467 298.981 114.402 296.33 113.522 294.277C112.643 292.212 110.284 297.222 106.753 296.635C103.221 296.049 101.743 293.397 100.57 291.332C99.3966 289.268 98.2112 293.104 92.6146 291.919C87.018 290.746 89.3764 282.499 89.3764 282.499C89.3764 282.499 84.0731 285.443 81.1281 283.085C78.1832 280.727 77.3034 275.436 77.0101 271.893C76.7168 268.362 72 272.773 72 266.297C72 259.822 76.118 254.519 76.7168 252.466L76.7046 252.503Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.709 297.771L127.306 296.11L134.174 308.316L133.709 297.771Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.931 268.044C146.931 269.608 147.481 270.867 148.165 270.867C148.85 270.867 149.4 269.596 149.4 268.044C149.4 266.493 148.85 265.222 148.165 265.222C147.481 265.222 146.931 266.493 146.931 268.044Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.754 260.982C149.754 260.982 147.285 259.919 144.451 262.4",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.925 361.526L199.305 365.51L215.178 364.043C215.178 364.043 237.027 371.46 232.775 372.902C228.51 374.343 223.549 372.804 223.549 372.804C223.549 372.804 217.06 375.516 210.645 375.37C204.217 375.223 200.001 373.94 200.001 373.94L144.927 382.224L149.925 361.526Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.816 298.908C113.816 298.908 142.263 326.436 146.846 333.314C151.428 340.193 153.273 346.156 153.273 352.118C153.273 358.081 149.143 371.387 149.143 371.387L154.654 391.119L170.711 405.793L145.477 446.162C145.477 446.162 134.003 448.459 126.207 443.865C118.41 439.284 113.364 419.551 113.364 409.923C113.364 400.295 115.197 379.646 115.197 379.646C115.197 379.646 104.639 346.62 101.437 334.231C98.2235 321.841 97.7713 310.833 100.973 304.87C104.187 298.908 109.233 295.694 113.816 298.908Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.846 333.314C147.811 334.768 148.654 336.173 149.387 337.554C137.314 339.228 120.818 341.794 104.553 345.264C103.918 343.113 103.319 341.073 102.794 339.204C118.142 335.917 133.697 333.424 145.673 331.726C146.161 332.337 146.552 332.862 146.858 333.314H146.846Z",
    fill: "#62B6FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.046 332.691C100.533 330.578 100.105 328.525 99.7632 326.521L132.989 317.968C134.724 319.74 136.422 321.499 138.011 323.173L101.059 332.679L101.046 332.691Z",
    fill: "#62B6FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.402 377.166C113.926 375.651 113.254 373.525 112.447 370.996C124.496 370.116 137.73 369.114 150.072 368.173C149.522 370.104 149.131 371.387 149.131 371.387L149.998 374.502C138.316 375.394 125.877 376.323 114.39 377.166H114.402Z",
    fill: "#62B6FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.969 320.436C98.7735 318.09 98.7246 315.891 98.8346 313.851L121.502 306.446C123.054 307.986 124.753 309.672 126.512 311.431L98.9568 320.424L98.969 320.436Z",
    fill: "#62B6FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.577 445.026C138.707 436.95 151.636 426.638 163.684 417.01L153.64 433.089C147.689 437.83 141.872 442.472 136.606 446.676C134.027 446.529 131.192 446.065 128.577 445.026Z",
    fill: "#62B6FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.83 383.935C127.844 383.715 141.176 383.373 152.332 382.811L154.068 389.03C142.337 389.653 128.113 390.032 114.341 390.252C114.512 387.869 114.683 385.682 114.83 383.935Z",
    fill: "#62B6FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.626 346.144C153.065 348.16 153.273 350.139 153.273 352.118C153.273 352.216 153.273 352.326 153.273 352.424C140.32 352.803 124.068 354.208 107.779 355.943C107.144 353.878 106.521 351.813 105.91 349.785C122.492 347.989 139.184 346.547 152.626 346.144Z",
    fill: "#62B6FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.652 409.068C158.43 406.856 163.037 404.742 167.375 402.751L170.711 405.793L168.646 409.092C164.711 410.888 160.581 412.794 156.304 414.774C144.89 420.052 130.178 425.281 117.115 429.533C116.431 427.554 115.82 425.501 115.319 423.473C128.211 419.282 142.654 414.151 153.664 409.055L153.652 409.068Z",
    fill: "#62B6FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.352 409.923C113.352 408.481 113.388 406.783 113.462 404.938C128.956 402.458 144.622 398.536 158.369 394.528L163.782 399.476C148.666 404.009 130.899 408.579 113.376 411.316C113.352 410.827 113.339 410.363 113.339 409.911L113.352 409.923Z",
    fill: "#62B6FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.928 529.198L239.532 546.633C239.532 546.633 251.459 550.299 253.291 552.144C255.124 553.976 251.459 554.893 246.864 556.726C242.282 558.558 225.296 555.809 219.797 555.345C214.286 554.881 209.239 555.345 207.407 550.763C205.574 546.181 207.407 541.135 207.871 539.29C208.335 537.457 210.62 528.281 210.62 528.281L223.928 529.198Z",
    fill: "#9C9C9C",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.302 546.878C242.954 547.721 251.727 550.58 253.291 552.144C255.124 553.976 251.459 554.893 246.864 556.725C242.282 558.558 225.296 555.809 219.797 555.345C214.298 554.881 209.239 555.345 207.407 550.763C205.574 546.181 207.407 541.135 207.871 539.29C207.92 539.082 208.005 538.777 208.091 538.398C216.107 543.42 229.732 548.918 232.64 548.918C234.62 548.918 237.797 547.855 240.302 546.865V546.878Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.265 498.921C270.265 498.921 288.154 518.641 290.451 521.403C292.749 524.152 299.628 525.068 299.164 528.281C298.7 531.495 291.368 530.578 288.154 530.114C284.94 529.65 264.753 524.604 262.004 523.687C259.255 522.771 255.576 521.39 255.124 517.261C254.66 513.131 257.874 502.586 257.874 502.586L270.265 498.921Z",
    fill: "#9C9C9C",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.124 517.273C254.843 514.695 255.98 509.624 256.884 506.166C261.393 508.366 265.743 514.316 267.979 515.44C270.729 516.821 291.832 523.699 291.832 523.699L292.798 523.162C295.682 524.75 299.519 525.862 299.176 528.294C298.712 531.507 291.38 530.591 288.166 530.126C284.953 529.662 264.766 524.616 262.016 523.699C259.267 522.783 255.589 521.402 255.137 517.273H255.124Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.918 303.465C107.901 301.254 115.869 305.237 118.52 309.66L122.064 322.929L134.895 365.839L199.317 365.522C199.317 365.522 217.549 361.502 220.2 361.563C222.852 361.624 236.379 370.336 236.343 371.655C236.318 372.987 232.775 372.902 232.775 372.902L226.591 372.315L219.981 370.837C219.981 370.837 214.188 372.474 211.537 372.413C208.885 372.352 204.926 371.374 204.926 371.374C204.926 371.374 135.335 387.05 130.899 387.05C126.463 387.05 121.612 385.719 119.84 382.627C118.068 379.536 99.4943 333.522 98.6023 323.344C97.7225 313.166 99.9342 305.652 103.906 303.441L103.918 303.465Z",
    fill: "#9C9C9C",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.359 372.169C232.359 372.169 222.095 366.695 220.946 366.463",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.547 363.494C222.547 363.494 234.18 370.104 234.864 372.621",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0486 310.161L91.4293 309.745C91.4293 309.745 110.309 364.312 112.765 384.827C115.221 405.341 114.402 422.569 113.18 428.311C111.946 434.054 105.384 445.136 105.384 445.136L97.1725 447.189C97.1725 447.189 105.787 425.037 106.203 418.879C106.618 412.721 105.555 388.309 104.969 385.23C100.46 361.429 84.0364 310.149 84.0364 310.149L84.0486 310.161Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.108 519.411C150.108 519.411 190.727 539.925 191.558 544.434C192.376 548.942 191.558 554.685 191.558 554.685L190.116 553.243L186.218 544.006L149.693 526.779L150.108 519.399V519.411Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.165 553.048C184.165 555.54 186.181 557.556 188.674 557.556C191.166 557.556 193.183 555.54 193.183 553.048C193.183 550.555 191.166 548.539 188.674 548.539C186.181 548.539 184.165 550.555 184.165 553.048Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.206 519.411C138.206 519.411 97.5881 539.925 96.7571 544.434C95.9384 548.942 96.7571 554.685 96.7571 554.685L98.1991 553.243L102.097 544.006L138.622 526.779L138.206 519.399V519.411Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.15 553.048C104.15 555.54 102.134 557.556 99.6411 557.556C97.1483 557.556 95.132 555.54 95.132 553.048C95.132 550.555 97.1483 548.539 99.6411 548.539C102.134 548.539 104.15 550.555 104.15 553.048Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.493 452.528H148.055V523.919H141.493V452.528Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.931 459.505H154.214V472.639H134.931V459.505Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7489 446.285C112.96 444.794 158.735 440.823 199.769 446.321C201.321 446.529 201.932 448.459 200.783 449.535C196.421 453.652 184.323 461.142 152.98 463.182C120.598 465.296 104.064 455.363 97.6125 449.999C96.1706 448.801 96.8793 446.468 98.7489 446.272V446.285Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.82 449.51C200.82 449.51 200.771 449.559 200.747 449.583C200.405 449.901 199.952 450.072 199.488 450.072H97.6736C97.6736 450.072 97.6247 450.036 97.6003 450.011C96.1706 448.814 96.8915 446.48 98.7489 446.285C112.973 444.794 158.735 440.823 199.769 446.321C201.297 446.529 201.944 448.435 200.82 449.498V449.51Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.984 512.838H152.161V528.843H136.984V512.838Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.95 520.84H146.21V557.556H143.95V520.84Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.106 547.989H147.078V557.605H143.106V547.989Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.176 450.072H138.206L143.95 395.09H137.791L129.176 450.072Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.584 398.78H175.55C175.55 398.78 171.041 390.569 168.169 389.751C165.297 388.932 118.52 389.751 118.52 389.751C118.52 389.751 113.596 391.388 113.596 398.78H113.584Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.55 398.78H113.584C113.584 398.035 113.645 397.363 113.73 396.727H174.328C175.061 397.912 175.537 398.78 175.537 398.78H175.55Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.619 387.71L360.629 405.708C358.149 410.815 357.183 419.49 357.843 425.135L374.242 555.125C374.425 556.616 373.265 557.947 371.762 557.947C370.552 557.947 369.525 557.092 369.293 555.907L337.974 389.445H349.448L351.465 399.024C351.807 400.649 354.08 400.759 354.593 399.183L358.467 386.989L367.619 387.71Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.585 394.797H338.976L337.974 389.445H349.448L350.585 394.797Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.479 386.989L367.619 387.71L364.87 394.797H355.986L358.479 386.989Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.154 387.71L198.144 405.708C200.625 410.815 201.59 419.49 200.93 425.135L184.531 555.125C184.348 556.616 185.509 557.947 187.012 557.947C188.222 557.947 189.248 557.092 189.48 555.907L220.799 389.445H209.325L207.309 399.024C206.967 400.649 204.694 400.759 204.181 399.183L200.307 386.989L191.154 387.71Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.325 389.445H220.799L219.797 394.797H208.201L209.325 389.445Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.788 394.797H193.904L191.155 387.71L200.307 386.989L202.788 394.797Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.006 378.718H379.888V389.384H178.006V378.718Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.975 375.712H244.567V378.791H192.975V375.712Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.666 378.107H298.162C302.134 378.107 305.396 375.003 305.616 371.044C305.665 370.214 305.568 369.383 305.335 368.576L291.234 328.036C290.941 327.181 290 326.729 289.144 327.022C288.289 327.315 287.837 328.256 288.13 329.111L302.207 369.578C302.317 369.945 302.366 370.409 302.342 370.886C302.219 373.097 300.386 374.844 298.175 374.844H275.678C274.774 374.844 274.041 375.577 274.041 376.482C274.041 377.386 274.774 378.119 275.678 378.119L275.666 378.107Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.47 272.529L256.615 367.684L259.34 369.725C259.34 369.725 290.623 345.252 290.623 324.847C290.623 304.443 285.185 273.176 285.185 273.176L281.482 272.529H281.47Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.47 272.529L285.185 273.176L259.34 369.725L256.615 367.684L281.47 272.529Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.279 359.498C350.279 359.498 359.102 345.374 352.039 337.432C344.976 329.49 333.502 333.314 331.156 340.67C328.797 348.025 333.807 360.378 333.807 360.378L350.279 359.498Z",
    fill: "#62B6FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.986 343.321C351.453 343.321 357.049 341.256 358.809 338.617C360.568 335.966 360.874 330.089 355.864 330.089C350.854 330.089 349.094 338.91 349.094 338.91L348.801 342.148",
    fill: "#62B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.986 343.321C351.453 343.321 357.049 341.256 358.809 338.617C360.568 335.966 360.874 330.089 355.864 330.089C350.854 330.089 349.094 338.91 349.094 338.91L348.801 342.148",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.465 337.823C346.785 337.163 350.866 332.826 351.257 329.673C351.66 326.521 349.29 321.121 344.817 323.357C340.345 325.593 342.703 334.28 342.703 334.28L343.888 337.31",
    fill: "#62B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.465 337.823C346.785 337.163 350.866 332.826 351.257 329.673C351.66 326.521 349.29 321.121 344.817 323.357C340.345 325.593 342.703 334.28 342.703 334.28L343.888 337.31",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.125 339.301C340.858 338.031 341.848 332.154 340.418 329.307C339.001 326.46 334.039 323.283 331.547 327.621C329.066 331.958 335.848 337.872 335.848 337.872L338.512 339.729",
    fill: "#62B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.125 339.301C340.858 338.031 341.848 332.154 340.418 329.307C339.001 326.46 334.039 323.283 331.547 327.621C329.066 331.958 335.848 337.872 335.848 337.872L338.512 339.729",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.365 349.846C338.61 348.392 337.51 342.539 335.188 340.364C332.866 338.19 327.111 336.919 326.292 341.855C325.461 346.791 333.881 349.992 333.881 349.992L337.021 350.823",
    fill: "#62B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.365 349.846C338.61 348.392 337.51 342.539 335.188 340.364C332.866 338.19 327.111 336.919 326.292 341.855C325.461 346.791 333.881 349.992 333.881 349.992L337.021 350.823",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.161 335.062L357.171 336.626",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.326 338.898L353.762 340.169",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.025 332.08L355.473 334.353",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.334 336.198L351.636 339.326",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.363 328.672L348.801 330.382",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.371 333.498L346.381 334.915",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.799 325.263L346.528 328.109",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.772 345.288L352.345 347.842",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.489 350.249L350.927 352.375",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.072 345.423L349.51 348.257",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.226 350.249L347.799 352.375",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.237 341.733L346.381 345.704",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.245 349.54L345.11 351.385",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.681 340.462L342.972 344.152",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.972 347.976L342.691 351.813",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.563 341.879V344.995",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.99 348.978L339.856 351.385",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.019 327.108L336.728 328.818",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.009 330.797L337.718 333.217",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.891 330.382L334.027 332.655",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.447 335.208L337.718 336.626",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.147 330.235L339.563 332.08",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.891 340.462L334.455 343.016",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.457 344.568L336.3 346.84",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.174 347.976L331.62 346.559",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.056 340.462L331.339 342.588",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.773 342.869L330.484 344.152",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.618 354.574H354.752V378.705H330.618V354.574Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.082 381.906L467.086 516.051",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.825 490.368L458.483 483.672",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.414 485.676C460.414 485.676 460.597 482.707 457.884 480.288C456.259 478.834 447.681 475.23 446.862 478.248C445.982 481.534 454.756 487.986 460.401 485.676H460.414Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.414 485.676L452.251 480.593",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.414 505.629L460.072 498.921",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.002 500.937C462.002 500.937 462.186 497.968 459.473 495.549C457.848 494.095 449.269 490.49 448.451 493.508C447.571 496.795 456.345 503.246 461.99 500.937H462.002Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.002 500.937L453.839 495.854",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.939 453.151L454.597 446.443",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.528 448.447C456.528 448.447 456.711 445.478 453.998 443.059C452.373 441.605 443.795 438.001 442.976 441.019C442.096 444.305 450.87 450.756 456.516 448.447H456.528Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.528 448.447L448.365 443.364",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.528 468.4L456.186 461.704",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.116 463.708C458.116 463.708 458.3 460.739 455.587 458.32C453.962 456.866 445.383 453.261 444.565 456.279C443.685 459.566 452.459 466.017 458.104 463.708H458.116Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.116 463.708L449.954 458.625",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.349 428.36L452.007 421.665",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.937 423.669C453.937 423.669 454.121 420.7 451.408 418.28C449.783 416.826 441.204 413.222 440.386 416.24C439.506 419.527 448.28 425.978 453.925 423.669H453.937Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.937 423.669L445.775 418.586",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.758 403.472L449.404 396.776",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.334 398.78C451.334 398.78 451.518 395.811 448.805 393.392C447.18 391.938 438.602 388.333 437.783 391.351C436.903 394.638 445.677 401.089 451.322 398.78H451.334Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.335 398.78L443.172 393.697",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.762 481.351L468.589 473.482",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.11 475.841C467.11 475.841 466.316 472.981 468.467 470.049C469.762 468.29 477.399 462.987 478.829 465.773C480.369 468.803 473.122 476.928 467.11 475.828V475.841Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.11 475.841L474.466 468.815",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.571 441.202L464.397 433.333",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.919 435.691C462.919 435.691 462.124 432.832 464.275 429.9C465.57 428.14 473.208 422.838 474.637 425.623C476.177 428.654 468.931 436.779 462.919 435.679V435.691Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.919 435.691L470.275 428.666",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.725 423.559L462.552 415.69",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.086 418.048C461.086 418.048 460.291 415.189 462.442 412.257C463.737 410.497 471.375 405.195 472.804 407.98C474.344 411.01 467.098 419.136 461.086 418.036V418.048Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.086 418.048L468.43 411.023",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.025 397.692L459.852 389.824",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.385 392.194C458.385 392.194 457.591 389.335 459.742 386.403C461.037 384.643 468.674 379.341 470.104 382.126C471.644 385.157 464.397 393.282 458.385 392.182V392.194Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.385 392.194L465.729 385.169",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.96 381.161C452.96 381.161 452.165 378.302 454.316 375.37C455.611 373.61 463.249 368.308 464.678 371.093C466.218 374.123 458.972 382.249 452.96 381.149V381.161Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.96 381.161L460.316 374.136",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.387 381.467C453.387 381.467 450.455 381.955 447.766 379.512C446.153 378.046 441.681 369.884 444.601 368.76C447.779 367.538 455.098 375.614 453.375 381.467H453.387Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.387 381.467L447.18 373.415",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.01 400.381L476.092 534.525",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.171 508.94L474.332 501.071",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.811 503.442C475.811 503.442 476.605 500.583 474.442 497.65C473.147 495.891 465.497 490.6 464.08 493.386C462.54 496.416 469.798 504.541 475.798 503.442H475.811Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.811 503.442L468.87 496.783",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.032 471.711L478.193 463.842",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.672 466.213C479.672 466.213 480.466 463.353 478.303 460.421C477.008 458.662 469.359 453.371 467.941 456.157C466.401 459.187 473.66 467.312 479.66 466.213H479.672Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.672 466.213L472.731 459.554",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.444 486.971L476.617 479.103",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.083 481.461C478.083 481.461 478.865 478.602 476.715 475.669C475.419 473.91 467.77 468.62 466.352 471.405C464.813 474.435 472.071 482.561 478.071 481.461H478.083Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.083 481.461L471.155 474.802",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.599 446.932L480.772 439.064",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.25 441.422C482.25 441.422 483.032 438.563 480.882 435.63C479.586 433.871 471.937 428.58 470.519 431.366C468.98 434.396 476.238 442.521 482.238 441.422H482.25Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.25 441.422L475.31 434.763",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.189 422.031L483.35 414.175",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.829 416.533C484.829 416.533 485.611 413.674 483.46 410.742C482.165 408.982 474.515 403.692 473.098 406.477C471.558 409.508 478.817 417.633 484.816 416.533H484.829Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.829 416.533L477.888 409.874",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.977 499.886L486.319 493.178",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.401 495.194C484.401 495.194 484.218 492.225 486.918 489.806C488.543 488.352 497.122 484.736 497.928 487.753C498.82 491.04 490.047 497.491 484.389 495.182L484.401 495.194Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.401 495.194L493.04 489.83",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.144 459.737L490.486 453.029",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.568 455.045C488.568 455.045 488.385 452.076 491.085 449.657C492.71 448.203 501.289 444.586 502.095 447.604C502.987 450.891 494.213 457.342 488.556 455.033L488.568 455.045Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.568 455.045L497.207 449.681",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.977 442.094L492.319 435.386",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.389 437.402C490.389 437.402 490.205 434.433 492.906 432.014C494.531 430.56 503.109 426.943 503.916 429.961C504.808 433.248 496.034 439.699 490.376 437.39L490.389 437.402Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.389 437.402L499.028 432.038",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.666 416.228L495.008 409.52",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.077 411.536C493.077 411.536 492.894 408.567 495.594 406.148C497.219 404.694 505.798 401.077 506.604 404.095C507.496 407.382 498.722 413.833 493.065 411.524L493.077 411.536Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.077 411.536L501.716 406.172",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.047 399.623C490.047 399.623 489.863 396.654 492.564 394.235C494.189 392.781 502.767 389.164 503.574 392.182C504.466 395.469 495.692 401.92 490.034 399.611L490.047 399.623Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.047 399.623L498.686 394.259",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.401 400.014C490.401 400.014 487.431 399.88 485.305 396.935C484.022 395.163 481.334 386.256 484.425 385.767C487.786 385.23 493.285 394.626 490.401 400.014Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.401 400.014L485.977 390.85",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.051 345.753V515.391",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.185 489.879L468.576 482.561",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.287 484.76C470.287 484.76 470.776 481.828 468.332 479.14C466.866 477.527 458.715 473.043 457.591 475.963C456.369 479.14 464.434 486.458 470.287 484.748V484.76Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.287 484.76L462.699 478.846",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.185 458.002L468.576 450.683",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.287 452.882C470.287 452.882 470.776 449.95 468.332 447.262C466.866 445.649 458.715 441.165 457.591 444.085C456.369 447.262 464.434 454.581 470.287 452.87V452.882Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.287 452.882L462.699 446.969",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.185 420.577L468.576 413.246",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.287 415.446C470.287 415.446 470.776 412.513 468.332 409.825C466.866 408.212 458.715 403.728 457.591 406.649C456.369 409.825 464.434 417.144 470.287 415.433V415.446Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.287 415.446L462.699 409.544",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.185 395.664L468.576 388.333",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.287 390.533C470.287 390.533 470.776 387.6 468.332 384.912C466.866 383.299 458.715 378.815 457.591 381.735C456.369 384.912 464.434 392.231 470.287 390.52V390.533Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.287 390.533L462.699 384.631",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.185 370.629L468.576 363.31",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.287 365.51C470.287 365.51 470.776 362.577 468.332 359.889C466.866 358.276 458.715 353.792 457.591 356.712C456.369 359.889 464.434 367.208 470.287 365.497V365.51Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.287 365.51L462.699 359.596",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.063 499.617L479.684 492.299",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.973 494.498C477.973 494.498 477.485 491.566 479.929 488.877C481.395 487.265 489.545 482.781 490.67 485.701C491.892 488.877 483.827 496.196 477.973 494.486V494.498Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.973 494.498L486.014 488.267",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.063 448.912L479.684 441.593",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.973 443.792C477.973 443.792 477.485 440.86 479.929 438.172C481.395 436.559 489.545 432.075 490.67 434.995C491.892 438.172 483.827 445.49 477.973 443.78V443.792Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.973 443.792L486.014 437.561",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.063 423.888L479.684 416.57",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.973 418.769C477.973 418.769 477.485 415.837 479.929 413.149C481.395 411.536 489.545 407.052 490.67 409.972C491.892 413.149 483.827 420.467 477.973 418.757V418.769Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.973 418.769L486.014 412.538",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.063 390.814L479.684 383.483",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.973 385.682C477.973 385.682 477.485 382.75 479.929 380.062C481.395 378.449 489.545 373.965 490.67 376.885C491.892 380.062 483.827 387.38 477.973 385.67V385.682Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.973 385.682L486.014 379.463",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.063 364.813L479.684 357.482",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.973 359.681C477.973 359.681 477.485 356.749 479.929 354.061C481.395 352.448 489.545 347.964 490.67 350.884C491.892 354.061 483.827 361.38 477.973 359.669V359.681Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.973 359.681L486.014 353.462",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.733 348.147C473.733 348.147 473.244 345.215 475.688 342.527C477.155 340.914 485.305 336.43 486.429 339.35C487.651 342.527 479.586 349.846 473.733 348.135V348.147Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.733 348.147L481.774 341.928",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.124 348.49C474.124 348.49 471.155 348.673 468.748 345.96C467.293 344.335 463.701 335.758 466.719 334.939C470.006 334.06 476.446 342.845 474.136 348.49H474.124Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.124 348.49L468.772 339.851",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.041 559.389H463.065L460.817 514.023H483.277L481.041 559.389Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 564,
    height: 560,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFirstStep);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/IconFirstStep.b338995527975abc93f34ee51bf24813.svg";